import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ProductAddPageConfig } from '@front-platform/content-builder';
import { productAddPageResolveConfig } from '@front-platform/content-builder';
import { ActivatedRoute } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Component, inject, input, OnDestroy, OnInit, computed } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import { ContentStoreDispatcher } from '@common/dispatchers/content.dispatcher';
import {
  ProductAddModalComponent,
  ProductAddModalConfig,
} from '@shared/modals/product-add-modal/product-add-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
export interface ProductAddPageRuntimeConfig {
  'allow_add_to_cart'?: boolean;
}

export type ProductAddPageConfigInput = Partial<
  Omit<ProductAddPageConfig, keyof ProductAddPageRuntimeConfig> & ProductAddPageRuntimeConfig
>;
export type ProductAddPageResolvedConfig = Omit<
  ProductAddPageConfig,
  keyof ProductAddPageRuntimeConfig
> &
  Partial<ProductAddPageRuntimeConfig>;
export interface ProductAddPageContract extends ConfigComponentContract<
  ProductAddPageConfigInput,
  ProductAddPageResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-product-add-page',
  standalone: false,
})
export class ProductAddPageComponent implements OnInit, OnDestroy, ProductAddPageContract {
  readonly config = input<ProductAddPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ProductAddPageConfig,
    ProductAddPageRuntimeConfig
  >(productAddPageResolveConfig, () => ({ config: this.config() }));
  readonly allowAddToCart = computed(
    () => this.resolvedConfig()['allow_add_to_cart'] as unknown as boolean,
  );

  private readonly location = inject(LocationStrategy);
  private readonly modalsService = inject(ModalsService<ProductAddModalConfig>);
  private readonly activatedRoute = inject(ActivatedRoute);
  private contentDispatcher = inject(ContentStoreDispatcher);

  constructor() {
    this.modalsService
      .event$('product-add-modal')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        if (event.type === 'close') {
          this.location.back();
        }
      });
  }

  ngOnInit(): void {
    this.contentDispatcher.updateProduct({
      shopIsNotActive: false,
      shopId: this.activatedRoute.snapshot.params.shopId,
      productId: this.activatedRoute.snapshot.params.productId,
    });

    const isDigitalMenu = this.location.path().includes('/menu');

    this.modalsService.open(ProductAddModalComponent.handle, undefined, {
      allowAddToCart: !isDigitalMenu && this.allowAddToCart(),
    });
  }

  ngOnDestroy(): void {
    this.modalsService.close(ProductAddModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ProductAddPageComponent, { 'keyAliases': {} });
